@import "../../constants.scss";

.tree-nodes-container {
  height: 100%;
  overflow: auto;

  &.with-search {
    height: calc(100% - 39px);
  }
}

.tree-wrapper {
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
  padding: 7px 0;

  .tree-nodes-wrap {
    height: 100%;
    padding: var(--spacing-1) var(--padding-m) var(--spacing-2) var(--spacing-2);

    .input-wrap {
      padding-bottom: 0;
    }
    &.no-data {
      height: 220px;

      &.is-small {
        height: auto;
        margin-top: -20px;
      }
    }
    &.is-loading {
      padding-top: 10px;
      padding-left: 44px;
      .tree-loader-title {
        margin-top: var(--spacing-2);
        margin-bottom: 14px;
      }
      table {
        margin-left: var(--spacing-8);
      }
      tr {
        display: block;
        margin-bottom: 18px;
      }
    }
  }

  &.has-checkbox {
    margin-bottom: 0;
    padding: var(--spacing-1) 0px 0px 0px;

    .tree-node-wrapper {
      div[class^="tree-node-wrapper-data-"]:hover {
        background: transparent;
      }
      .tree-node-data:hover {
        color: var(--input-color-hover);
      }
    }
  }

  &.borderless-nodes {
    overflow-y: auto;
    color: var(--text-color-main);
    &.dropdown-tree.has-checkbox {
      .expandable-indicator {
        padding-left: 5px;
        &.is-expandable-hidden {
          opacity: 0;
          width: 0;
          flex: 0 0 auto;
        }
      }
    }

    .tree-node-wrapper {
      .expandable-indicator {
        .seem-icon-chevron-down {
          color: var(--dropdown-item-color);
        }
      }
      &.is-selected {
        @for $i from 0 through 10 {
          > .tree-node-wrapper-data-#{$i} {
            background-color: var(--dropdown-item-background-selected);
            &:hover {
              background-color: var(--dropdown-item-background-selected);

              .tree-node-label-container {
                color: var(--text-color-soft);
              }
            }

            .tree-node-data {
              &.is-root {
                color: var(--dropdown-item-color);
                &:hover {
                  background-color: var(--dropdown-item-background-hover);
                  color: var(--text-color-soft);
                }
              }
            }
          }
        }
      }

      @for $i from 0 through 10 {
        .tree-node-wrapper-data-#{$i} {
          &:hover {
            background-color: var(--dropdown-background-color);

            .tree-node-data {
              border: none;
              background-color: transparent;

              &.is-root {
                background-color: transparent;
              }
            }
          }
        }
      }

      .tree-node {
        height: 32px;
        padding-right: 10px;
        margin-top: 0;

        &.is-selected {
          .tree-node-data {
            border: none;
            background-color: transparent;
            color: var(--dropdown-item-color);
          }
        }

        .tree-node-data {
          border: none;
          background-color: transparent;
          border-radius: 0;
        }
      }
    }
  }
}
